import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-157" data-mp="2atgz6inza65g">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center px-3 pb-3 md:pb-5" data-id="element-158" data-mp="38bh3m8un0a4d">
          <a href={CHECKOUT_URL} className="animate-cta-shake pointer-events-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl border-2 border-white/80 bg-cta px-5 py-4 font-display text-[17px] font-black uppercase tracking-wide text-white shadow-[0_6px_0_0_#15803d,0_12px_30px_-8px_rgba(6,18,31,0.5)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-159" data-mp="33319bm7outkb">
            <span className="whitespace-nowrap" data-id="element-160" data-mp="2kaozkeepgq05">Get TRT Blueprint — $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-161" data-mp="26f4ou694re3t" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}